import { render, staticRenderFns } from "./deleteAttendanceClasses.vue?vue&type=template&id=e584c6f8&scoped=true"
import script from "./deleteAttendanceClasses.vue?vue&type=script&lang=js"
export * from "./deleteAttendanceClasses.vue?vue&type=script&lang=js"
import style0 from "./deleteAttendanceClasses.vue?vue&type=style&index=0&id=e584c6f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_29ccf6a1548590c1291b44f0faebdb79/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e584c6f8",
  null
  
)

export default component.exports